import React from 'react';
import styles from './HowItWorks.module.css';
import global from '../../styles/global.module.css';

import CircleBackground from '../../assets/images/3-bg.svg';
import Step1Image from '../../assets/images/Business Deal.svg';
import Step2Image from '../../assets/images/Shipping.svg';
import Step3Image from '../../assets/images/Smart Home Control.svg';
import Counter1 from '../../assets/images/counter_1.png';
import Counter2 from '../../assets/images/counter_2.png';
import Counter3 from '../../assets/images/counter_3.png';
import Arrow from '../../assets/images/arrow.svg';

const HowItWorks = () => {
  return (
    <section className={global.section} id="funciona">
      <div className={global.sectionHeader}>
        <h2>Como funciona</h2>
        <p>
          Nosso processo é simples, direto e eficiente: você define o que precisa, nós cuidamos da entrega e da gestão. Sem complicações, com total transparência.
        </p>
      </div>

      <div className={styles.stepsContainer}>
        <div className={styles.step}>
          <div className={styles.circle}>
            <img src={CircleBackground} alt="Fundo círculo" className={styles.bgCircle} />
            <img src={Step1Image} alt="Etapa 1" className={styles.icon} />
            <img src={Counter1} alt="1" className={styles.counter} />
          </div>
          <h3>Negociação sob medida</h3>
          <p>Acordos flexíveis com volume, validade e condições comerciais que se adaptam à sua realidade.</p>
        </div>

        <img src={Arrow} alt="Seta" className={styles.arrow} />

        <div className={styles.step}>
          <div className={styles.circle}>
            <img src={CircleBackground} alt="Fundo círculo" className={styles.bgCircle} />
            <img src={Step2Image} alt="Etapa 2" className={styles.icon} />
            <img src={Counter2} alt="2" className={styles.counter} />
          </div>
          <h3>Distribuição rápida e segura</h3>
          <p>Vouchers digitais entregues direto à sua empresa ou integrados ao seu sistema.</p>
        </div>

        <img src={Arrow} alt="Seta" className={styles.arrow} />

        <div className={styles.step}>
          <div className={styles.circle}>
            <img src={CircleBackground} alt="Fundo círculo" className={styles.bgCircle} />
            <img src={Step3Image} alt="Etapa 3" className={styles.icon} />
            <img src={Counter3} alt="3" className={styles.counter} />
          </div>
          <h3>Gestão com suporte completo</h3>
          <p>Processo acompanhado por uma equipe dedicada, com clareza e agilidade do início ao fim.</p>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
